import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import keyHeaders from './keyHeaders'

/**
 * Expected payload for POST /study/reviewer endpoint
 */
export interface ICreateReviewer {
  email: string
  firstName?: string
  lastName?: string
  npi?: string
  password?: string
  isApproved?: boolean
}

interface ICreateReviewerResponseBody extends ICreateReviewer {
  email: string
  firstName: string
  lastName: string
  npi: string
}

/**
 * Expected response for POST /study/reviewer endpoint
 */
export interface ICreateReviewerResponse extends AxiosResponse {
  data: ICreateReviewerResponseBody
}

export function createReviewer(data: ICreateReviewer, query?: string): Promise<ICreateReviewerResponse> {
  const url = (() => {
    if (!query) return '/study/reviewer'
    return `/study/reviewer?${query}`
  })()
  return Client.post(url, data, { ...keyHeaders(), validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/createReviewer.ts